/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], () => {

	class MediaBase {
		constructor(url, type) {
			this.url = url;
			this.type = type;
		}

		/**
		 * Abstract: needs to be implemented by concrete subclass
		 * @return an object with 'width' and 'height' members
		 */
		getDimensions() {
			return null;
		}

		/**
		 * Abstract: needs to be implemented by concrete subclass
		 * @param an object of parameters
		 * @return the markup representing this media
		 */
		getMarkup() {
			return '';
		}

		/**
		 * A callback for when markup is loaded into the DOM.
		 * @param The root element into which the markup was placed
		 */
		markupLoaded($el, mode) {
			if(mode === 'authoring') {
				this.showAuthoringMode();
			} else {
				this.showConsumeMode();
			}
		}

		/**
		 * Invoke to render the media in authoring mode
		 */
		showAuthoringMode() {}

		/**
		 * Invoke to render the media in consume mode
		 */
		showConsumeMode() {}
	}
	return MediaBase;
});
